
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 11.992c0-1.356-.596-2.635-1.605-3.44a4.578 4.578 0 00-1.327-3.637c-.959-.959-2.28-1.444-3.567-1.297-1.68-2.132-5.308-2.172-6.949-.03-2.696-.32-5.29 2.219-4.934 4.895-2.132 1.68-2.173 5.308-.03 6.95a4.579 4.579 0 001.327 3.638c.959.958 2.283 1.443 3.567 1.296 1.68 2.132 5.309 2.172 6.95.03a4.58 4.58 0 003.636-1.326c.959-.96 1.442-2.286 1.297-3.568A4.577 4.577 0 0022 11.993zM8.655 9.49c.005-1.09 1.664-1.09 1.668 0-.005 1.09-1.663 1.09-1.668 0zm2.363 5.467a.834.834 0 01-1.388-.926l3.336-5.004a.833.833 0 111.388.926l-3.336 5.004zm3.476.371c-1.091-.005-1.091-1.663 0-1.668 1.09.005 1.09 1.663 0 1.668z"}})])
          )
        }
      }
    